import { render, staticRenderFns } from "./PageReclamations.vue?vue&type=template&id=a1c7d602&"
import script from "./PageReclamations.vue?vue&type=script&lang=js&"
export * from "./PageReclamations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports